interface ValidatePasswordResult {
    isValid: boolean
    validationMessage: string
}

//eslint-disable-next-line
const PASSWORD_REGEX = "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/\\?]).{8,}$";

const EMPTY_PASSWORD_VALIDATION_MESSAGE = "Please enter your password";
const INVALID_PASSWORD_LOGIN_MESSAGE = "Wrong password. Try again or click Forgot Password to reset it";
const INVALID_PASSWORD_REGISTRATION_MESSAGE = "Password does not met requirements";

const validatePasswordEmpty = (password: string): ValidatePasswordResult => {
    const isPasswordValid = password != '';
    return {
        isValid: isPasswordValid,
        validationMessage: isPasswordValid ? "" : EMPTY_PASSWORD_VALIDATION_MESSAGE
    };
}

const validatePasswordRegex = (password: string, isRegister: boolean): ValidatePasswordResult => {
    const regex = new RegExp(PASSWORD_REGEX);
    const isPasswordValid = regex.test(password);

    return {
        isValid: isPasswordValid,
        validationMessage: isPasswordValid ? "" : isRegister ? INVALID_PASSWORD_REGISTRATION_MESSAGE : INVALID_PASSWORD_LOGIN_MESSAGE
    };
}

export default function validatePassword(password: string, isValidateRegex: boolean, isRegister) {
    let result: ValidatePasswordResult = {
        isValid: true,
        validationMessage: "" 
    };
    result = validatePasswordEmpty(password);
    if (!result.isValid) return result;

    if (isValidateRegex)
    {
        result = validatePasswordRegex(password, isRegister);
        if (!result.isValid) return result;
    }
    
    return result;
}



